import { useCachedApiCall } from '@hooks/apiCall';
import type { OrgEmployeeRequestsParams } from '@api/OrgEmployeeRequestService';
import {
    orgEmployeeRequestCache,
    orgEmployeeRequestsCache,
} from './orgEmployeeRequestStore';

/*
 * Thin cache-backed bindings so hooks and features don't hand-roll
 * param arrays. See docs/api-caching.md §8 for the hook contract.
 */

/** Cache-backed org employee request list. */
export const useOrgEmployeeRequestsEntry = (
    orgId?: string,
    orgEmployeeId?: string,
    params?: OrgEmployeeRequestsParams,
) => useCachedApiCall(orgEmployeeRequestsCache, [orgId, orgEmployeeId, params]);

/** Cache-backed detail of one org employee request (explicit fetch). */
export const useOrgEmployeeRequestEntry = (
    orgId?: string,
    orgEmployeeId?: string,
    requestId?: string,
    shouldCallInitially = false,
) =>
    useCachedApiCall(
        orgEmployeeRequestCache,
        [orgId, orgEmployeeId, requestId],
        [orgId, orgEmployeeId, requestId],
        shouldCallInitially,
    );
